import { Button, type ButtonProps } from '@heroui/react';
import { Icon } from '@iconify/react';
import { useEffect, useState } from 'react';

export interface CollapseProps extends ButtonProps {
    icon?: React.ReactNode;
    collapse?: boolean;
    onCollapsedChange?: (isCollapsed: boolean) => void;
}

export const Collapse: React.FC<CollapseProps> = ({ icon, collapse, onCollapsedChange, ...buttonProps }) => {

    const [isCollapsed, setCollapsed] = useState(collapse || false);

    const handleCollpsedChange = () => {
        setCollapsed(!isCollapsed);
    }

    useEffect(() => {
        onCollapsedChange?.(isCollapsed);
    }, [isCollapsed, onCollapsedChange]);

    return (
        <Button
            className="bg-default-[0]"
            size="sm"
            radius="sm"
            variant="flat"
            isIconOnly
            aria-label="Sidebar Collapse Button"
            startContent={icon || (
                <Icon
                    width={24}
                    icon={`${isCollapsed ? "solar:round-alt-arrow-right-line-duotone" : "solar:round-alt-arrow-left-line-duotone"}`}
                />
            )}
            onPress={handleCollpsedChange}
            {...buttonProps}
        />
    )
}